import controller from './category.controller';
import templateT1 from './templates/category-t1.view.html';

let CategoryComponent = {
    template: changeTemplate,
    controller,
    bindings: {
        shCtrl: '<'
    }
};

changeTemplate.$inject = ['SessionService'];

function changeTemplate(SessionService) {
    let response = SessionService.get('components');
    return templateT1;
}

export default CategoryComponent;



/** WEBPACK FOOTER **
 ** ./www/components/catalog/category/category.component.js
 **/